import React, {useEffect, useState} from "react";
import axios from "axios";

interface FileItem {
  id: string;
  name: string;
  description?: string;
  size: number;
  lastModifiedDate: string;
  url: string;
  mimeType: string;
  children?: FileItem[];
}

const MeasurementForms: React.FC = () => {
  const [currentFiles, setCurrentFiles] = useState<FileItem[]>([]);
  const [history, setHistory] = useState<FileItem[][]>([]);
  const [language, setLanguage] = useState<string>("fr");

  useEffect(() => {
    fetchFolder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchFolder = (parentId?: string, folderName?: string) => {
    const url = parentId
        ? `api/files?parentId=${parentId}`
        : "api/files";

    axios.get<FileItem[]>(url).then((res) => {
      const items = res.data;
      if (!parentId) {
        setCurrentFiles(items);
      } else {
        setHistory((h) => [...h, currentFiles]);
        setCurrentFiles(items);
      }
    });
  };

  const handleOpen = (file: FileItem) => {
    if (file.children && file.children.length > 0) {
      setHistory((h) => [...h, currentFiles]);
      setCurrentFiles(file.children as FileItem[]);
    } else {
      fetchFolder(file.id, file.name);
    }
  };

  const handleBack = () => {
    if (history.length === 0) return;
    const prev = history[history.length - 1];
    setHistory((h) => h.slice(0, -1));
    setCurrentFiles(prev);
  };

  const formatSize = (bytes: number) => {
    if (!bytes || bytes === 0) {
      return "";
    }
    if (bytes < 1024) {
      return `${bytes} B`;
    }
    const kb = bytes / 1024;
    if (kb < 1024) {
      return `${kb.toFixed(2)} KB`;
    }
    return `${(kb / 1024).toFixed(2)} MB`;
  };

  const parseDescription = (desc: string | undefined) => {
    if (!desc) return "";
    try {
      const obj = JSON.parse(desc);
      return obj[language] || "";
    } catch {
      return desc;
    }
  };

  return (
      <div className="container">
        <img src="/lamelcolor.png" alt="Lamelcolor Logo" className="logo"/>
        <h1 className="header">{language === "fr" ? "Modèles de fiches de mesures (MFO)" : "Messblattmodelle (MFO)"}</h1>

        {(!currentFiles || currentFiles.length === 0) && (
            <div className="loading">
              <img src="/loading.svg" alt="loading"/>
            </div>
        )}

        {(currentFiles && currentFiles.length > 0) && (
            <>
              {history.length > 0 && (
                  <span onClick={handleBack} className="back-button">
                  <i className="fa-solid fa-chevron-left"></i>&nbsp;
                    {language === "fr" ? "Retour" : "Zurück"}
                </span>
              )}
              <div className="table-wrapper">
                <table className="file-table" role="table">
                  <thead>
                  <tr>
                    <td className="file-cell file-type"></td>
                    <td className="file-cell file-name">{language === "fr" ? "Nom" : "Name"}</td>
                    <td className="file-cell file-description">{language === "fr" ? "Description" : "Beschreibung"}</td>
                    <td className="file-cell file-size">{language === "fr" ? "Taille" : "Größe"}</td>
                    <td className="file-cell file-date">{language === "fr" ? "Modification" : "Änderung"}</td>
                    <td className="file-cell file-actions">{language === "fr" ? "Lien" : "Link"}</td>
                  </tr>
                  </thead>
                  <tbody>
                  {currentFiles.map((file) => (
                      <tr key={file.id} className={`file-row ${file.children ? 'folder-row' : ''}`}
                          onClick={() => {
                            if (file.children && file.children.length > 0) {
                              handleOpen(file)
                            } else {
                              window.open(file.url, "_blank");
                            }
                          }}>
                        <td>
                          <img src={'https://drive-thirdparty.googleusercontent.com/16/type/' + file.mimeType} alt="file-ico"/>
                        </td>
                        <td className="file-cell file-name">{file.name}</td>
                        <td className="file-cell file-description">{parseDescription(file.description)}</td>
                        <td className="file-cell file-size">{formatSize(file.size)}</td>
                        <td className="file-cell file-date">{new Date(file.lastModifiedDate).toLocaleDateString()}</td>
                        <td className="file-cell file-actions">
                          {!file.children && (
                              <i className="fa-solid fa-download"></i>
                          )}
                        </td>
                      </tr>
                  ))}
                  </tbody>
                </table>
              </div>

              <div className="language-select">
                <label htmlFor="language" className="language-label">Langue :</label>
                <select
                    id="language"
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                    className="language-dropdown">
                  <option value="fr">FR</option>
                  <option value="de">DE</option>
                </select>
              </div>
            </>
        )}
      </div>
  );
};

export default MeasurementForms;